/**
 * Huisstijl-tokens, afgeleid uit het goedgekeurde klikbare prototype en de
 * Schoonderwolf-huisstijlhandleiding.
 */
export const theme = {
  color: {
    bg: '#F4F7FA',
    surface: '#FFFFFF',
    border: '#E3E6EB',
    borderStrong: '#D4D9E0',
    text: '#1C2430',
    muted: '#66707E',
    subtle: '#98A1AE',
    primary: '#155679',
    primaryDark: '#0C3551',
    primaryMid: '#164E6F',
    link: '#155679',
    accentBg: '#E3EEF5',
    warnBg: '#FBF3DA',
    warnBorder: '#EFDFA8',
    warnText: '#8A6A12',
    // Huisstijl-accent (geel) voor de primaire actieknop, conform prototype.
    cta: '#FAB001',
    ctaHover: '#E9A300',
    ctaText: '#0C3551',
    ok: '#157A4A',
  },
  font: {
    body: "'Montserrat', 'Helvetica Neue', Arial, sans-serif",
    mono: "'IBM Plex Mono', ui-monospace, monospace",
  },
  gradient: {
    header: 'linear-gradient(120deg, #164E6F 0%, #0C3551 100%)',
  },
} as const;
